<template>
  <IconLucideCalendarDays />
</template>
